// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"96":"FlightAttendantCartaRenuncia","499":"ThanksView"}[chunkId] + "." + {"96":"345bf723","499":"3be935fd"}[chunkId] + ".js";
};